import { truncateString } from 'GenericForms/Helper';
import React from 'react'
import { Link } from 'react-router-dom';
import { CSSModule } from 'reactstrap/types/lib/utils';

interface NotificationType {
    id: number;
    title: string;
    date: string;
    current_state: boolean;
    category: string;
    priority: string;
    innerRef?: React.Ref<HTMLElement>;
    cssModule?: CSSModule;
    [key: string]: any;
}

const NotificationDropdownItems: React.FC<NotificationType> = (notification) => {
    return (
        <Link to={`/notifications/${notification.notification_id}`} className="text-reset notification-item">
            <div className="d-flex">
                <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                        {notification.title}
                    </h6>
                    <div className="font-size-12 text-muted">
                        <p className="mb-1 text-truncate-line">
                            {truncateString(notification?.message, 45)}
                        </p>
                        <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {new Date(notification.date).toLocaleString()}{" "}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default NotificationDropdownItems
